module.exports = __webpack_public_path__ + "static/media/hal_btm_5.2c6acd28.png";